import { useState, useEffect } from "react";
import { api } from "@/lib/api";

/** 🏆 Weekly Bot Leaderboard — settled results from the last 7 days, ranked
 * by net. Real results when they exist; demo clearly labeled otherwise. */
const MEDALS = ["🥇", "🥈", "🥉"];

const BotLeaderboard = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data: d } = await api.get("/bot-leaderboard");
        if (alive) setData(d);
      } catch { /* silent */ }
    };
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const rows = data?.rows || [];
  if (!rows.length) return null;
  return (
    <div data-testid="bot-leaderboard" className="rounded-lg border border-amber-500/25 bg-vts-card p-3 space-y-2">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-lg">🏆</span>
        <h3 className="text-[13px] font-bold text-white">Weekly Bot Leaderboard</h3>
        <span className={`text-[8px] font-mono px-1.5 py-0.5 rounded border ${data.scope === "real" ? "bg-vts-profit/15 border-vts-profit/40 text-vts-profit" : "bg-amber-400/15 border-amber-400/40 text-amber-300"}`}>
          {data.scope === "real" ? "REAL RESULTS · LAST 7 DAYS" : "DEMO RESULTS · LAST 7 DAYS"}
        </span>
      </div>
      <div className="space-y-1">
        {rows.map((r, i) => (
          <div key={r.source} data-testid={`leaderboard-row-${r.source}`}
            className={`flex items-center gap-2 rounded-md border px-2 py-1.5 ${i === 0 ? "border-amber-400/40 bg-amber-400/5" : "border-vts-line/40 bg-vts-surface/30"}`}>
            <span className="text-[13px] w-6 text-center">{MEDALS[i] || `${i + 1}.`}</span>
            <span className="text-[12px]">{r.icon}</span>
            <span className="text-[11px] font-semibold text-white truncate">{r.label}</span>
            <span className="text-[9px] font-mono text-vts-silver/50">{r.trades}t · {r.wins}W/{r.losses}L · {r.win_rate}%</span>
            <span className={`ml-auto text-[12px] font-bold font-mono ${r.net >= 0 ? "text-vts-profit" : "text-vts-loss"}`}>
              {r.net >= 0 ? "+" : "−"}${Math.abs(r.net).toFixed(2)}
            </span>
          </div>
        ))}
      </div>
      <p className="text-[8px] font-mono text-vts-silver/35">Settled trades only, min 5 per bot. Last week is live evidence — never a promise about next week.</p>
    </div>
  );
};

export default BotLeaderboard;
